import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';
import firebase from 'firebase/app';
import 'firebase/firestore';

import { CardWrapper } from './CardWrapper';
import { ItemList } from './ItemList';
import { ItemListHeader } from './ItemListHeader';
import { ItemListFooter } from './ItemListFooter';

const db = firebase.firestore();

export const ItemCard = ({
  items,
  markItem,
  shopper,
  markShopper,
  list,
  listIndex
}) => {
  const [rollouts, setRollouts] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const rollouts = await db
          .collection('rollouts')
          .doc('aislesFeature')
          .get();

        if (rollouts) {
          setRollouts({
            id: rollouts.id,
            ...rollouts.data()
          });
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    fetchData();
  }, []);

  const time = `${format(list.time && list.time.toDate(), 'MM/DD/YYYY')}`;
  const store = list.store && list.store.address && list.store.address.name;
  return (
    <CardWrapper>
      <ItemListHeader
        store={store || 'Error'}
        time={time || 'Error'}
        long={(list.store && list.store.lon) || 'Error'}
        lat={(list.store && list.store.lat) || 'Error'}
        listId={list && list.id}
      />
      <Hr />
      <ItemList
        items={items}
        markItem={markItem}
        list={list}
        listIndex={listIndex}
        rollouts={rollouts}
      />
      <Hr />
      <ItemListFooter
        shopper={shopper}
        markShopper={markShopper}
        list={list}
        listIndex={listIndex}
      />
    </CardWrapper>
  );
};

const Hr = styled.hr`
  border-color: #c8c8c8;
`;
